/**
 * Presets a compare window may NOT use in the rule being edited (hour rules:
 * no rolling 24/48-hour windows). Provided by the rule form, read by the
 * compare controls — default: nothing excluded.
 * For Media Devoted | Created By Ciro Autiero
 */

import { createContext, useContext } from 'react';

const NONE: readonly string[] = [];

const WindowExclusionsContext = createContext<readonly string[]>(NONE);

export const CompareWindowExclusions = WindowExclusionsContext.Provider;

export function useCompareWindowExclusions(): readonly string[] {
  return useContext(WindowExclusionsContext);
}
